var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default function rowStyles(_a) {
    var minHeight = _a.minHeight, justifyContent = _a.justifyContent, _b = _a.flexGrow, flexGrow = _b === void 0 ? 0 : _b, isRtl = _a.isRtl, margin = _a.margin, zIndex = _a.zIndex;
    var _c = defineStartAndEnd(isRtl), start = _c.start, end = _c.end;
    var expandedMargin = expandMargin(margin) || {};
    var row = function () {
        var totalMargin = (expandedMargin.marginStart || 0) + (expandedMargin.marginEnd || 0);
        return {
            zIndex: zIndex,
            direction: (isRtl === true && 'rtl') || (isRtl === false && 'ltr') || 'inherit',
            boxSizing: 'border-box',
            width: totalMargin ? "calc(100% - " + totalMargin + "px)" : '100%',
            display: 'flex',
            flexWrap: 'wrap',
            flexShrink: 0,
            flexGrow: flexGrow,
            flexBasis: 'auto',
            alignItems: 'stretch',
            minHeight: minHeight
        };
    };
    var rowJustifyContent = function () {
        switch (justifyContent) {
            case 'center':
                return { justifyContent: 'center' };
            case 'end':
                return { justifyContent: 'flex-end' };
            case 'flex-end':
                return { justifyContent: 'flex-end' };
            default:
                return { justifyContent: 'flex-start' };
        }
    };
    var rowMargin = function () {
        var _a, _b;
        var marginStart = expandedMargin.marginStart, marginEnd = expandedMargin.marginEnd, marginTop = expandedMargin.marginTop, marginBottom = expandedMargin.marginBottom;
        return __assign(__assign(__assign(__assign({}, (marginStart
            ? (_a = {},
                _a["margin" + start] = marginStart + "px",
                _a) : {})), (marginEnd
            ? (_b = {},
                _b["margin" + end] = marginEnd + "px",
                _b) : {})), (marginTop ? { marginTop: marginTop } : {})), (marginBottom ? { marginBottom: marginBottom } : {}));
    };
    return __assign(__assign(__assign({}, row()), rowJustifyContent()), rowMargin());
}
// helpers
function expandMargin(margin) {
    if (!!margin || margin === 0) {
        if (typeof margin === 'number') {
            return {
                marginEnd: margin,
                marginStart: margin
            };
        }
        if (margin !== null) {
            return __assign(__assign(__assign(__assign({}, ((margin === null || margin === void 0 ? void 0 : margin.start) ? { marginStart: margin.start } : {})), ((margin === null || margin === void 0 ? void 0 : margin.end) ? { marginEnd: margin.end } : {})), ((margin === null || margin === void 0 ? void 0 : margin.top) ? { marginTop: margin.top } : {})), ((margin === null || margin === void 0 ? void 0 : margin.bottom) ? { marginBottom: margin.bottom } : {}));
        }
    }
    return {
        marginEnd: 0,
        marginStart: 0
    };
}
function defineStartAndEnd(isRtl) {
    return isRtl
        ? { start: 'Right', end: 'Left' }
        : { start: 'Left', end: 'Right' };
}
